// A tiny global store for the problem a learner is currently looking at, so the
// floating Professor Owl helper can offer a guided explanation of the EXACT
// question on screen, across every quiz, test and activity. Quiz surfaces
// publish here (QuestionReader does it automatically); the floating helper
// subscribes.
let _problem = null;
const _subs = new Set();

export function setActiveProblem(p) {
  _problem = p || null;
  _subs.forEach((fn) => { try { fn(_problem); } catch { /* noop */ } });
}

export function clearActiveProblem() { setActiveProblem(null); }
export function getActiveProblem() { return _problem; }

export function onActiveProblem(fn) {
  _subs.add(fn);
  try { fn(_problem); } catch { /* noop */ }
  return () => _subs.delete(fn);
}

// Learn context: the subject / lesson a learner is currently viewing (even when
// there is no discrete "problem" on screen). Lets the floating Professor Owl
// offer smart, one-tap suggestions like "Explain this lesson more" or
// "Tell me more about {subject}" without the learner typing anything.
let _learn = null;
const _lsubs = new Set();
export function setLearnContext(c) {
  _learn = c || null;
  _lsubs.forEach((fn) => { try { fn(_learn); } catch { /* noop */ } });
}
export function clearLearnContext() { setLearnContext(null); }
export function getLearnContext() { return _learn; }
export function onLearnContext(fn) {
  _lsubs.add(fn);
  try { fn(_learn); } catch { /* noop */ }
  return () => _lsubs.delete(fn);
}

// Auto Offer Help: quiz surfaces fire this when a learner answers wrong, so the
// floating Professor Owl can gently pop in with a hint about the current problem.
const _wrongSubs = new Set();
export function signalWrongAnswer() {
  _wrongSubs.forEach((fn) => { try { fn(_problem); } catch { /* noop */ } });
}
export function onWrongAnswer(fn) {
  _wrongSubs.add(fn);
  return () => _wrongSubs.delete(fn);
}
